import { render } from "./InputSelect.vue?vue&type=template&id=53c66c61&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=53c66c61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c66c61"]])

export default __exports__